import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "insertionPoint"]

  addSpace() {
    const token = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
    const content = this.templateTarget.innerHTML.replaceAll("NEW_BOOKABLE_SPACE", token)
    this.insertionPointTarget.insertAdjacentHTML("afterend", content)
  }
}
